import livingWithHighBloodPressureData from 'src/utils/navigator/living-with-high-blood-pressure/index';
import lowerYourCholesterolData from 'src/utils/navigator/lower-your-cholesterol/index';

const data = {
  'living-with-high-blood-pressure': livingWithHighBloodPressureData,
  'lower-your-cholesterol': lowerYourCholesterolData,
};

export const getTitle = (navigator) => {
  const navigatorIndex = data[navigator] || data['living-with-high-blood-pressure'];
  return navigatorIndex.title;
};

export const getPage = (navigator, selectedWeek, personalisation) => {
  const navigatorIndex = data[navigator] || data['living-with-high-blood-pressure'];
  return navigatorIndex.getPage(selectedWeek, personalisation);
};

export const getMenu = (navigator, selectedWeek, personalisation) => {
  const navigatorIndex = data[navigator] || data['living-with-high-blood-pressure'];
  return navigatorIndex.getMenu(selectedWeek, personalisation);
};

export const getBrandLogo = (navigator) => {
  const navigatorIndex = data[navigator] || data['living-with-high-blood-pressure'];
  return navigatorIndex.brandLogo;
};

export const getBannerImage = (navigator) => {
  const navigatorIndex = data[navigator] || data['living-with-high-blood-pressure'];
  return navigatorIndex.bannerImage;
};

export const getFooter = (navigator, selectedWeek) => {
  const navigatorIndex = data[navigator] || data['living-with-high-blood-pressure'];
  return navigatorIndex.getFooter(selectedWeek);
};
